import { render, staticRenderFns } from "./GeneralProductInformationStep.vue?vue&type=template&id=1c87d9ac&"
import script from "./GeneralProductInformationStep.vue?vue&type=script&lang=js&"
export * from "./GeneralProductInformationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports